import { CircularProgress, Typography } from '@mui/material';
import { Colors } from '../styles/colors';

type BigLoaderprops = {
  message: string;
};

export const BigLoader = (props: BigLoaderprops) => {
  const { message } = props;
  return (
    <>
      <CircularProgress size={100} sx={{ color: `${Colors.Menu} !important`, mb: 3 }} thickness={2.5} />
      <Typography sx={{ color: `${Colors.Menu} !important`, fontWeight: 500 }} variant='h4'>
        {message}
      </Typography>
    </>
  );
};
